import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";

@Component({
  selector: "app-prefix-hi2",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-hi2.component.html",
  styleUrl: "./prefix-hi2.component.less",
})
export class PrefixHi2Component extends PrefixComponent<string> {
  public constructor() {
    super();
    this.hide = true;
    this.characters = ALLOWED_CHARACTERS["hi2"];
  }
}
